module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 616
// module chunks = 0